import styled from 'styled-components';
import { palette } from 'styled-tools';

import {
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	lineHeight,
	maxWidth,
	minWidth,
	Text,
} from '@calm-web/design-system';

export const ProgramTitle = styled(Text).attrs({
	color: 'white',
	el: 'h1',
	size: FontSizes.xl,
	weight: FontWeights.Medium,
})`
	margin: 24px 0 8px 0;
	${minWidth('tablet')} {
		${fontSize(FontSizes['4xl'])};
		${lineHeight(FontSizes['4xl'])};
		${fontWeight(FontWeights.Regular)};
	}

	@media only screen and (max-height: 720px) {
		${fontSize(FontSizes['3xl'])};
		${lineHeight(FontSizes['3xl'])};
	}

	@media only screen and (max-height: 600px) {
		${fontSize(FontSizes.lg)};
		${lineHeight(FontSizes.lg)};
	}
`;

export const ProgramDescription = styled(Text).attrs({
	color: 'white',
	el: 'h2',
	weight: FontWeights.Regular,
	size: FontSizes.base,
	lineHeight: FontSizes.base,
})`
	&&& {
		${minWidth('tablet')} {
			${fontSize(FontSizes.lg)}
			${lineHeight(FontSizes.lg)}
		}
		margin-bottom: 40px;
		margin-top: 0;

		@media only screen and (max-height: 600px) {
			${fontSize(FontSizes.sm)};
			${lineHeight(FontSizes.sm)};
		}
	}
`;

export const GuideMetaContainer = styled.div<{
	$justifyContent: 'space-around' | 'center';
}>`
	color: ${palette('white')};
	display: flex;
	justify-content: ${p => p.$justifyContent};
	width: 100%;
`;

export const GuideMetaHeading = styled(Text).attrs({
	color: 'white',
	opacity: 0.8,
	uppercase: true,
	weight: FontWeights.Demi,
	noMargin: true,
	el: 'h3',
})`
	${lineHeight(FontSizes.base)};
	${fontSize(FontSizes.sm)};
	${minWidth('tablet')} {
		${fontSize(FontSizes.base)};
	}
`;

export const GuideMetaCopy = styled(Text).attrs({
	size: FontSizes.sm,
	lineHeight: FontSizes.sm,
	weight: FontWeights.Regular,
})`
	${minWidth('tablet')} {
		${fontSize(FontSizes.lg)};
		${lineHeight(FontSizes.lg)};
	}
	@media only screen and (max-height: 600px) {
		${fontSize(FontSizes.base)};
		${lineHeight(FontSizes.base)};
	}
`;

export const DesktopOnly = styled.div`
	${maxWidth('desktop')}, screen and (max-height: 720px) {
		display: none;
	}
`;
